import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId, waLink } from "@/lib/site";

const LINKS = [
  ["limpeza-comercial", "Comercial"],
  ["faxina-residencial", "Residencial"],
  ["limpeza-pos-obra", "Pós-obra"],
  ["duvidas", "Dúvidas"],
  ["orcamento", "Orçamento"],
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => { setOpen(false); scrollToId(id); };
  return (
    <header className="fixed top-0 inset-x-0 z-40 bg-[#FAF8F5]/80 backdrop-blur-xl border-b border-[#121518]/5">
      <nav className="max-w-[1400px] mx-auto px-5 md:px-10 h-[70px] flex items-center justify-between">
        <button data-testid="nav-logo" onClick={() => window.scrollTo({ top: 0 })} aria-label="Início">
          <Logo />
        </button>
        <div className="hidden lg:flex items-center gap-8">
          {LINKS.map(([id, label]) => (
            <button key={id} data-testid={`nav-link-${id}`} onClick={() => go(id)}
              className="relative text-sm text-[#525860] hover:text-[#121518] transition-colors after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-[#0F4C3A] hover:after:w-full after:transition-[width] after:duration-300">
              {label}
            </button>
          ))}
          <a data-testid="nav-button-whatsapp" href={waLink()} target="_blank" rel="noreferrer"
            className="rounded-full bg-[#0F4C3A] text-[#FAF8F5] text-sm px-5 py-2.5 hover:bg-[#0B382B] transition-colors">
            WhatsApp
          </a>
        </div>
        <button className="lg:hidden p-2" data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>
      {open && (
        <div className="lg:hidden border-t border-[#E6E2D8] bg-[#FAF8F5] px-5 py-6 flex flex-col gap-5" data-testid="nav-mobile-menu">
          {LINKS.map(([id, label]) => (
            <button key={id} onClick={() => go(id)} className="text-left font-serif-d text-3xl">{label}</button>
          ))}
          <a href={waLink()} target="_blank" rel="noreferrer" className="rounded-full bg-[#0F4C3A] text-[#FAF8F5] text-center py-3">
            Falar no WhatsApp
          </a>
        </div>
      )}
    </header>
  );
};
